// Vendors
import { AxiosResponse } from "axios";

// Api
import Api from "@/services/api/index";

// Models
import { CommonResponseIndex } from "@/models/common/response";

// Services
import { setNotification } from "@/services/app";
import { getStatus } from "@/services/app";

// Store
import Store from "@/store";

const getRequest = async (options: { uri: string; formData?: any; isProtected?: boolean; successNotification?: string; isSuccessNotificationVisible?: boolean; isErrorNotificationVisible?: boolean }): Promise<CommonResponseIndex> => {
  let response: CommonResponseIndex = new CommonResponseIndex();

  await Api({
    method: "GET",
    headers: {
      Authorization: `${options.isProtected ? Store.getters.getAuthenticationAccessToken : ""}`,
    },
    url: `${options.uri}`,
    params: options.formData,
  })
    .then((r: AxiosResponse) => {
      response = {
        data: r.data.data ?? null,
        message: options.successNotification ?? "",
        status: getStatus(r.status),
      };

      if (options.isSuccessNotificationVisible) {
        setNotification(response.message, response.status);
      }
    })
    .catch((e) => {
      response = {
        data: null,
        message: e.response.data.message,
        status: getStatus(e.response.status),
      };

      if (options.isErrorNotificationVisible) {
        setNotification(response.message, response.status);
      }
    });

  return response;
};

const postRequest = async (options: { uri: string; formData?: any; isProtected?: boolean; successNotification?: string; isSuccessNotificationVisible?: boolean; isErrorNotificationVisible?: boolean }): Promise<CommonResponseIndex> => {
  let response: CommonResponseIndex = new CommonResponseIndex();

  await Api({
    method: "POST",
    headers: {
      Authorization: `${options.isProtected ? Store.getters.getAuthenticationAccessToken : ""}`,
    },
    url: `${options.uri}`,
    data: options.formData,
  })
    .then((r: AxiosResponse) => {
      response = {
        data: r.data.data ?? null,
        message: options.successNotification ?? "",
        status: getStatus(r.status),
      };

      if (options.isSuccessNotificationVisible) {
        setNotification(response.message, response.status);
      }
    })
    .catch((e) => {
      response = {
        data: null,
        message: e.response.data.message,
        status: getStatus(e.response.status),
      };

      if (options.isErrorNotificationVisible) {
        setNotification(response.message, response.status);
      }
    });

  return response;
};

export { getRequest, postRequest };
